// Themes
export const DEFAULT_THEME = "";
export const ECONOMIC_THEME = "Approche économique";
export const ENVIRONMENTAL_THEME = "Approche environnementale";
export const SOCIAL_THEME = "Approche sociale";

// Petales
export const ECONOMIC_VIABILITY = {
  petale: "Viabilité économique",
  theme: ECONOMIC_THEME,
};
export const WORK_CONDITIONS = {
  petale: "Conditions de travail",
  theme: ECONOMIC_THEME,
};
export const RESILIENCE = { petale: "Résilience", theme: ECONOMIC_THEME };
export const AUTONOMY = { petale: "Autonomie", theme: ECONOMIC_THEME };
export const BIODIVERSITY = {
  petale: "Biodiversité",
  theme: ENVIRONMENTAL_THEME,
};
export const SOIL_FERTILITY = {
  petale: "Fertilité des sols",
  theme: ENVIRONMENTAL_THEME,
};
export const CLIMATE = {
  petale: "Climat & Energie",
  theme: ENVIRONMENTAL_THEME,
};
export const NATURAL_RESOURCES = {
  petale: "Ressources naturelles",
  theme: ENVIRONMENTAL_THEME,
};
export const FOOD_SAFETY = {
  petale: "Sécurité alimentaire",
  theme: SOCIAL_THEME,
};
export const PUBLIC_HEALTH = {
  petale: "Santé publique",
  theme: SOCIAL_THEME,
};
export const TASTE = { petale: "Goût & Terroir", theme: SOCIAL_THEME };
export const TERRITORY_CONNECTION = {
  petale: "Connexion au territoire",
  theme: SOCIAL_THEME,
};
